/* @flow */
import { get, set, expire } from 'cookies-js';

function isEnabled() {
  if (typeof document === 'undefined') {
    // running in server context
    return false;
  }

  // In IE, cookies can be enabled by default but disabled for this particular site. So, rather than
  // checking `window.navigator.cookieEnabled`, we do this instead...
  return 'cookie' in document && (
    document.cookie.length > 0 ||
    (document.cookie = 'test').indexOf.call(document.cookie, 'test') >= 0
  );
}

export default {
  isEnabled,
  /* eslint-disable object-shorthand */ // Flow complains
  get: get,
  set: set,
  expire: expire,
};



// WEBPACK FOOTER //
// ./src/lib/Cookies.js